import { SITE_URL } from "../seo/siteConfig";

export async function sharePlaatplan({
  siteUrl = SITE_URL,
  navigatorRef = typeof navigator !== "undefined" ? navigator : undefined,
  shareText = "Gratis zaagplanning voor plaatmateriaal: MDF, multiplex en meer.",
} = {}) {
  const payload = {
    title: "Plaatplan",
    text: shareText,
    url: siteUrl,
  };

  if (navigatorRef?.share) {
    try {
      await navigatorRef.share(payload);
      return { status: "shared" };
    } catch (error) {
      if (error?.name === "AbortError") return { status: "cancelled" };
      throw error;
    }
  }

  if (navigatorRef?.clipboard?.writeText) {
    await navigatorRef.clipboard.writeText(siteUrl);
    return { status: "copied" };
  }

  return { status: "unsupported" };
}
